import React, { useState, useRef } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { ToastMessgae } from "../utils/toast";

export default function BulkJobDoneUpload() {
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = e?.target?.files?.[0] || null;
    setFile(selected);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select an excel file first.");
      return;
    }
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios(
        `${baseUrl}/module/admin/bulk_report_excel_create`,
        {
          method: "POST",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
          data: formData,
        }
      );

      ToastMessgae(response?.data);
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      const closeButton = document.getElementById("closeBulkJobDoneModal");
      closeButton?.click();
    } catch (error) {
      ToastMessgae(
        error?.response?.data || {
          code: 500,
          message: "Failed to upload bulk job done file.",
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="modal fade custom-modal addbus-modal"
      id="addBulkJobDone"
      tabIndex={-1}
      aria-labelledby="addBulkJobDoneLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title" id="addBulkJobDoneLabel">
              Bulk job done
            </h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeBulkJobDoneModal"
            >
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3 text-start">
                <label className="form-label">Upload Scheduler File</label>
                <input
                  ref={fileInputRef}
                  type="file"
                  className="form-control"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileChange}
                />
                <small className="text-muted d-block mt-2">
                  Accepted formats: .xlsx, .xls, .csv
                </small>
              </div>

              <div className="mb-3 text-start">
                <div>
                  Sample file:
                  <a
                    href="/scheduler_cleaning_sample.xlsx"
                    download="scheduler_cleaning_sample.xlsx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-success border-success"
                  >
                    &nbsp;Download
                  </a>
                </div>
              </div>

              <div className="text-end">
                <button type="submit" className="thm-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
